// extracted by mini-css-extract-plugin
export default {"capacityWrapper":"PeoplePlaceholderGroup-module__capacityWrapper___iXE1H"};